<!DOCTYPE html>
<html lang="en">

<head>
  <meta charset="utf-8">
  <meta content="width=device-width, initial-scale=1.0" name="viewport">
  <link
    href="https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&family=Open+Sans:wght@400;500;600&display=swap"
    rel="stylesheet">
  <title>SAION - Tecnología gubernamental</title>
  <meta content="" name="description">
  <meta content="" name="keywords">

  <!-- Favicons -->
  <link href="/assets/img/favicon.png" rel="icon">
  <link href="/assets/img/apple-touch-icon.png" rel="apple-touch-icon">
  <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css" rel="stylesheet">

  <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/js/bootstrap.bundle.min.js"></script>

  <!-- Google Fonts -->
  <link
    href="https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,600i,700,700i|Roboto:300,300i,400,400i,500,500i,600,600i,700,700i|Poppins:300,300i,400,400i,500,500i,600,600i,700,700i"
    rel="stylesheet">

  <!-- Vendor CSS Files -->
  <link href="/assets/vendor/animate.css/animate.min.css" rel="stylesheet">
  <link href="/assets/vendor/aos/aos.css" rel="stylesheet">
  <link href="/assets/vendor/bootstrap/css/bootstrap.min.css" rel="stylesheet">
  <link href="/assets/vendor/bootstrap-icons/bootstrap-icons.css" rel="stylesheet">
  <link href="/assets/vendor/boxicons/css/boxicons.min.css" rel="stylesheet">
  <link href="/assets/vendor/glightbox/css/glightbox.min.css" rel="stylesheet">
  <link href="/assets/vendor/remixicon/remixicon.css" rel="stylesheet">
  <link href="/assets/vendor/swiper/swiper-bundle.min.css" rel="stylesheet">

  <!-- Template Main CSS File -->
  <link href="/assets/css/style.css" rel="stylesheet">

  <!-- =======================================================
  * Template Name: Company - v4.7.0
  * Template URL: https://bootstrapmade.com/company-free-html-bootstrap-template/
  * Author: BootstrapMade.com
  * License: https://bootstrapmade.com/license/
  ======================================================== -->
</head>

<body>

  <!-- ======= Header ======= -->


  <!-- ======= Hero Section ======= -->

  <div id="mainCarousel" class="carousel slide carousel-fade" data-bs-ride="carousel" data-bs-interval="5000"
    data-aos="fade-up">

    <!-- Indicadores -->
    <div class="carousel-indicators">
      <button type="button" data-bs-target="#mainCarousel" data-bs-slide-to="0" class="active"></button>
      <button type="button" data-bs-target="#mainCarousel" data-bs-slide-to="1"></button>
      <button type="button" data-bs-target="#mainCarousel" data-bs-slide-to="2"></button>
    </div>

    <!-- Slides -->
    <div class="carousel-inner">

      <div class="carousel-item active">
        <img [src]="this.bann[0].IMAGEN" class="d-block w-100" alt="Slide 1">

      </div>

      <div class="carousel-item">
        <img [src]="this.bann[1].IMAGEN" class="d-block w-100" alt="Slide 2">

      </div>

      <div class="carousel-item">
        <img [src]="this.bann[2].IMAGEN" class="d-block w-100" alt="Slide 3">

      </div>

    </div>

    <!-- Controles -->
    <button class="carousel-control-prev" type="button" data-bs-target="#mainCarousel" data-bs-slide="prev">
      <span class="carousel-control-prev-icon"></span>
    </button>

    <button class="carousel-control-next" type="button" data-bs-target="#mainCarousel" data-bs-slide="next">
      <span class="carousel-control-next-icon"></span>
    </button>

  </div>



  <main id="main">

    <!-- ======= About Us Section ======= -->
    <section style="background-color: rgb(255, 255, 255);">
      <div class="container" data-aos="fade-up" style="background-color: rgb(255, 255, 255);">

        <div class="row content">
          <div class="col-lg-6" data-aos="fade-right">
            <img src="https://i.imgur.com/4QJL4Dx.png" alt="">
            <h3 style="text-align: justify;"></h3>

          </div>
          <div class="col-lg-6 pt-4 pt-lg-0" data-aos="fade-left">

            <h5 style="color: #660966; font-weight: bolder; font-size: 4vh;font-family: Poppins;">Teresa Gómez Núñez

            </h5>
            <h6 style="color: #df0ccd; font-weight: bolder;font-family: Poppins;">Presidenta Sistema DIF Municipal de
              Casimiro Castillo</h6>
            <p style="text-align: justify;font-family: Poppins;">
              “El trabajo por la integridad de las familias ha sido la oportunidad más valiosa
              que la vida me ha brindado”.
              <br>
              <br>
              Queridas familias de Casimiro Castillo: velar por sus necesidades ha sido mi
              prioridad desde el primer día. Hoy me siento satisfecha, pero sobre todo
              comprometida a seguir trabajando por nuestros adultos mayores, la niñez y
              las familias en situación de vulnerabilidad.
              <br>
              <br>
              Junto a un equipo que entrega el corazón, hemos logrado transformar vidas
              llevando alimento, atención médica y la esperanza de saber que en el DIF
              siempre encontrarán apoyo. Nuestra insignia es trabajar con amor y no
              descansaremos en nuestra misión de mejorar la calidad de vida de quienes
              más lo necesitan.
              <br><br>
              <img src="https://i.imgur.com/XcVYsPT.png" alt="">
            </p>

          </div>
        </div>

      </div>
    </section><!-- End About Us Section -->


    <!-- ======= Services Section ======= -->



    <section style="background-color: #EDB1D1;" id="services" class="services section-bg">
      <div class="container" style="background-color: #EDB1D1;" data-aos="fade-up">



        <div style="text-align: center;">
          <h1 style="color: #794591;font-family: Poppins; font-weight: 1000; margin-bottom: 3vh;">
            PROGRAMAS Y SERVICIOS</h1>
        </div>



        <div class="row">

          <div class="col-4">
            <div class="card mb-3" id="card1" style="max-width: 355px; height: 100px;border-radius: 2vh;">
              <div class="row g-0">
                <div class="col-md-4">
                  <img src="https://i.imgur.com/IVbV2oK.png"
                    style="border-top-left-radius: 2vh;border-bottom-left-radius: 2vh;" alt="...">
                </div>
                <div class="col-md-8">
                  <div class="card-body">
                    <h5 class="card-title mb-3 hide-mobile"
                      style="font-family: Poppins;font-weight: 900; color: #E71D73; font-size: 3vh;">Alimentación
                      Escolar</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <div class="col-4">
            <div class="card mb-3" id="card1" style="max-width: 355px; height: 100px;border-radius: 2vh;">
              <div class="row g-0">
                <div class="col-md-4">
                  <img src="https://i.imgur.com/df6CaBy.png"
                    style="border-top-left-radius: 2vh;border-bottom-left-radius: 2vh;" alt="...">
                </div>
                <div class="col-md-8">
                  <div class="card-body">
                    <h5 class="card-title mb-3 hide-mobile"
                      style="font-family: Poppins;font-weight: 900; color: #E71D73; font-size: 3vh;">Primeros Dias</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>




          <div class="col-4">
            <div class="card mb-3" id="card1" style="max-width: 355px; height: 100px;border-radius: 2vh;">
              <div class="row g-0">
                <div class="col-md-4">
                  <img src="https://i.imgur.com/0w6MeaT.png"
                    style="border-top-left-radius: 2vh;border-bottom-left-radius: 2vh;" alt="...">
                </div>
                <div class="col-md-8">
                  <div class="card-body">
                    <h5 class="card-title mb-3 hide-mobile"
                      style="font-family: Poppins;font-weight: 900; color: #E71D73; font-size: 3vh;">UBR</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>




          <div class="col-4">
            <div class="card mb-3" id="card1" style="max-width: 355px; height: 100px;border-radius: 2vh;">
              <div class="row g-0">
                <div class="col-md-4">
                  <img src="https://i.imgur.com/0aCNaI6.png"
                    style="border-top-left-radius: 2vh;border-bottom-left-radius: 2vh;" alt="...">
                </div>
                <div class="col-md-8">
                  <div class="card-body">
                    <h5 class="card-title mb-3 hide-mobile"
                      style="font-family: Poppins;font-weight: 900; color: #E71D73; font-size: 3vh;">CAIC</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>




          <div class="col-4">
            <div class="card mb-3" id="card1" style="max-width: 355px; height: 100px;border-radius: 2vh;">
              <div class="row g-0">
                <div class="col-md-4">
                  <img src="https://i.imgur.com/7AaCDOS.png"
                    style="border-top-left-radius: 2vh;border-bottom-left-radius: 2vh;" alt="...">
                </div>
                <div class="col-md-8">
                  <div class="card-body">
                    <h5 class="card-title mb-3 hide-mobile"
                      style="font-family: Poppins;font-weight: 900; color: #E71D73; font-size: 2.5vh;">Trabajo Social
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>






          <div class="col-4">
            <div class="card mb-3" id="card1" style="max-width: 355px; height: 100px;border-radius: 2vh;">
              <div class="row g-0">
                <div class="col-md-4">
                  <img src="https://i.imgur.com/5fkKe3j.png"
                    style="border-top-left-radius: 2vh;border-bottom-left-radius: 2vh;" alt="...">
                </div>
                <div class="col-md-8">
                  <div class="card-body">
                    <h5 class="card-title mb-3 hide-mobile"
                      style="font-family: Poppins;font-weight: 900; color: #E71D73; font-size: 3vh;">UAVIFAM</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>



          <div class="col-4">
            <div class="card mb-3" id="card1" style="max-width: 355px; height: 100px;border-radius: 2vh;">
              <div class="row g-0">
                <div class="col-md-4">
                  <img src="https://i.imgur.com/IgAws8b.png"
                    style="border-top-left-radius: 2vh;border-bottom-left-radius: 2vh;" alt="...">
                </div>
                <div class="col-md-8">
                  <div class="card-body">
                    <h5 class="card-title mb-3 hide-mobile"
                      style="font-family: Poppins;font-weight: 900; color: #E71D73; font-size: 3vh;">Centro de Dia y
                      APCE</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>




          <div class="col-4">
            <div class="card mb-3" id="card1" style="max-width: 355px; height: 100px;border-radius: 2vh;">
              <div class="row g-0">
                <div class="col-md-4">
                  <img src="https://i.imgur.com/ongFk8w.png"
                    style="border-top-left-radius: 2vh;border-bottom-left-radius: 2vh;" alt="...">
                </div>
                <div class="col-md-8">
                  <div class="card-body">
                    <h5 class="card-title mb-3 hide-mobile"
                      style="font-family: Poppins;font-weight: 900; color: #E71D73; font-size: 3vh;">Psicología</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>




          <div class="col-4">
            <div class="card mb-3" id="card1" style="max-width: 355px; height: 100px;border-radius: 2vh;">
              <div class="row g-0">
                <div class="col-md-4">
                  <img src="https://i.imgur.com/HQTfqWl.png"
                    style="border-top-left-radius: 2vh;border-bottom-left-radius: 2vh;" alt="...">
                </div>
                <div class="col-md-8">
                  <div class="card-body">
                    <h5 class="card-title mb-3 hide-mobile"
                      style="font-family: Poppins;font-weight: 900; color: #E71D73; font-size: 3vh;">Nutrición</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>






        </div>

      </div>
    </section>



    <section class="container">
      <div class="container py-5">
        <div class="row text-center py-3">
          <div class="col-lg-6 m-auto">
            <h1 class="h1" style="color: #794591;font-family: Poppins; font-weight: 1000; margin-bottom: 1vh;">Noticias
            </h1>


          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-4 mb-4" *ngFor="let noticia of data">
            <div class="card" style="max-width: 450px;border-radius: 2vh;" id="cardh" data-aos="fade-up">
              <a href="admin/ver-noticia/{{noticia.ID}}">
                <img [src]="noticia.ENLACE" height="400" style="border-radius: 2vh;" class="card-img-top" alt="...">
              </a>
              <!-- <div class="card-body">

                <a href="admin/ver-noticia/{{noticia.ID}}" style="text-align: center; ">{{noticia.ENCABEZADO}}</a>


              </div> -->
            </div>
          </div>

        </div>
      </div>


    </section>


    <section style="background-color: #EDB1D1;" id="services" class="services section-bg">
      <div class="container py-5">
        <div class="row text-center py-3">
          <div class="col-lg-6 m-auto">
            <h1 class="h1" style="color: #794591;font-family: Poppins; font-weight: 1000; margin-bottom: 1vh;">Eventos
            </h1>


          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-4 mb-4" *ngFor="let eve of eventos">
            <div class="card" style="max-width: 450px;border-radius: 2vh;" id="cardh" data-aos="fade-up">
              <a href="{{eve.URL}}">
                <img [src]="eve.IMG" height="400" style="border-radius: 2vh;" class="card-img-top" alt="...">
              </a>
              <!-- <div class="card-body">

                <a href="admin/ver-noticia/{{noticia.ID}}" style="text-align: center; ">{{noticia.ENCABEZADO}}</a>


              </div> -->
            </div>
          </div>

        </div>
      </div>


    </section>




  </main>

  <hr>
  <a href="#" class="back-to-top d-flex align-items-center justify-content-center"><i
      class="bi bi-arrow-up-short"></i></a>

  <!-- Vendor JS Files -->
  <script src="/assets/vendor/aos/aos.js"></script>
  <script src="/assets/vendor/bootstrap/js/bootstrap.bundle.min.js"></script>
  <script src="/assets/vendor/glightbox/js/glightbox.min.js"></script>
  <script src="/assets/vendor/isotope-layout/isotope.pkgd.min.js"></script>
  <script src="/assets/vendor/swiper/swiper-bundle.min.js"></script>
  <script src="/assets/vendor/waypoints/noframework.waypoints.js"></script>
  <script src="/assets/vendor/php-email-form/validate.js"></script>

  <!-- Template Main JS File -->
  <script src="/assets/js/main.js"></script>

</body>

</html>
